// import $ from "jquery";
import generalTools from "./tools";
import toolsBootstrap from "./toolsBootstrap";
import trackingTools from "../tracking/TrackingTools";

// import jquery from "jquery";
// window.$ = window.jQuery = jquery

// var jQuery = $;
// jQuery = window.$ = window.jQuery = $;

// import "../../../node_modules/jquery-history/dist/jquery.history.min";

/// acum de facut history link
// acum trebuie de facut si la categoriii sa apara cu link  cu ajax

var BASECLASSFUNCT = function () {
  this.OnLoadArr = new Array();
  this.OnReadyArr = new Array();

  this.OnUnLoadArr = new Array();
  this.OnReadyEventsArr = new Array();
  this.CommandExecuters = new Array();
  this.loadedScripts = new Array();

  this.BeginedInSite = 1;
  this.siteStartLocation;
  this.targetid;
  this.currentformid = "";

  this.needtwocheck = false;
  this.isPopState = false;

  // ============================================================================
  this.CommandExecuterAdd = function (com_name, func) {
    this.CommandExecuters[com_name] = func;
  };

  // ============================================================================
  this.loadScript = function (url) {
    var siteversion = generalTools.getSiteVersion();
    if (url.indexOf("?") >= 0) url += "&v=" + siteversion;
    else url += "?v=" + siteversion;

    for (var i in this.loadedScripts) {
      if (this.loadedScripts[i] == url) return true;
    }

    // set options
    var options = {
      dataType: "script",
      cache: true,
      url: url,
      async: false,
    };

    this.loadedScripts[this.loadedScripts.length + 1] = url;

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    $.ajax(options);
    return true;
  };

  // ============================================================================
  this.isforalways = function (obj) {
    var always = obj.attr("always");
    if (always == undefined) return false;
    if (always != "1") return false;
    return true;
  };

  // ============================================================================
  this.closeObjectsOnClick = function () {
    $(".dropdown-menu").removeClass("show");
    $(".navbar-collapse").removeClass("show");
    $(".js_hiderefresh").hide();
  };

  // ============================================================================
  this.bodyClick = function () {
    this.closeObjectsOnClick();
  };

  // ============================================================================
  this.OnLoadArrAdd = function (func) {
    this.OnLoadArr[this.OnLoadArr.length + 1] = func;
  };

  // ============================================================================
  this.OnLoadAll = function () {
    this.onLoadProcessLoad();

    for (var i in this.OnLoadArr) this.OnLoadArr[i]();
  };

  // ============================================================================
  this.OnReadyArrAdd = function (func) {
    this.OnReadyArr[this.OnReadyArr.length + 1] = func;
  };

  // ============================================================================
  this.OnReadyAll = function () {
    for (var i in this.OnReadyArr) this.OnReadyArr[i]();
  };

  // ============================================================================
  this.isDomElement = function (obj) {
    return (
      obj instanceof Element ||
      (obj instanceof jQuery && obj.length > 0 && obj[0] instanceof Element)
    );
  };

  // ============================================================================
  this.ParseForAjax = function (obj, type, objParams) {
    objParams = objParams == undefined ? false : objParams;

    type = type != undefined ? type : "ajaxHTML";
    var rez = {};

    rez.closeonclick = true;
    rez.type = type;

    if (objParams && objParams.type != undefined && objParams.type) {
      rez.type = objParams.type;
    }

    var href = false;

    if (this.isDomElement(obj)) {
      obj.attr("href");
      if (!href || href == undefined) href = obj.attr("href");
      if (!href || href == undefined) href = obj.attr("data-href");
      rez.scrolltargetid = obj.attr("data-scrolltargetid");
      rez.scrollindent = obj.attr("data-scrollindent");
      rez.savepreload = obj.attr("data-savepreload");
      rez.preloadtimeout = obj.attr("data-preloadtimeout");
      rez.inbackground = obj.attr("data-inbackground");
      rez.targetid = obj.attr("data-targetid");
      rez.stopother = obj.attr("data-stopother");
      if (obj.attr("data-closedialog") != undefined) {
        toolsBootstrap.bsCloseDialog(obj);
      }
      if (
        obj.attr("data-noncloseonclick") != undefined &&
        obj.attr("data-noncloseonclick")
      ) {
        rez.closeonclick = false;
      }
    }

    if (
      objParams &&
      objParams.scrolltargetid != undefined &&
      objParams.scrolltargetid
    ) {
      rez.scrolltargetid = objParams.scrolltargetid;
    }

    if (
      objParams &&
      objParams.scrollindent != undefined &&
      objParams.scrollindent
    ) {
      rez.scrollindent = objParams.scrollindent;
    }

    if (
      objParams &&
      objParams.noncloseonclick != undefined &&
      objParams.noncloseonclick
    ) {
      rez.closeonclick = false;
    }

    if (
      objParams &&
      objParams.inbackground != undefined &&
      objParams.inbackground
    ) {
      rez.inbackground = objParams.inbackground;
    }

    if (
      (!href || href == undefined) &&
      objParams &&
      objParams.href != undefined
    ) {
      href = objParams.href;
    }

    if (!href || href == undefined) return false;

    var url = href;
    url += url.indexOf("?") != -1 ? "&" : "?";
    url += "rt=ajax";

    rez.href = href;
    rez.url = url;

    if (
      (!rez.targetid || rez.targetid == undefined) &&
      objParams &&
      objParams.targetid != undefined
    )
      rez.targetid = objParams.targetid;
    if (!rez.targetid || rez.targetid == undefined) rez.targetid = "main";

    if (
      (!rez.stopother || rez.stopother == undefined) &&
      objParams &&
      objParams.stopother != undefined
    )
      rez.stopother = objParams.stopother;
    if (!rez.stopother || rez.stopother == undefined) rez.stopother = 0;

    return rez;
  };

  // ============================================================================
  this.loadPrefechAjax = function (obj, objParams, _method, _dataType) {
    var info = this.ParseForAjax(obj, "ajaxHTML", objParams);
    if (!info) return false;

    return this.loadAjaxPreloaded(info, _method, _dataType);
  };

  // ============================================================================
  this.loadDataAjax = function (obj, objParams, _method, _dataType) {
    var info = this.ParseForAjax(obj, "ajaxHTML", objParams);
    if (!info) return false;

    return this.getAjaxHTML(info, _method, _dataType);
  };

  // ============================================================================
  this.processPopState = function (event) {
    if (event.state && event.state.data) {
      baseClass.processAjaxResultSuccess(
        event.state.data,
        event.state.info,
        "success",
        null,
      );

      if (event.state.info.metaInfo)
        this.processMetaGen(event.state.info.metaInfo);
    } else if (event.state && event.state.info) {
      baseClass.getAjaxHTML(event.state.info);
    }
  };

  // ============================================================================
  this.loadDataAjaxHistory = function (obj, objParams) {
    var info = this.ParseForAjax(obj, "ajaxHistory", objParams);
    if (!info) return false;
    info.showLoading = true;

    return this.getAjaxHTML(info);
  };

  // ============================================================================
  this.onLoadProcessHeaderRequest = function (obj) {
    var _html = obj.val();
    obj.remove();

    if (_html == undefined) return;

    var values = JSON.parse(_html);

    if (values && values != undefined && values.metaInfo != undefined) {
      this.processMetaGen(values.metaInfo);
    }

    if (values && values.commands != undefined) {
      this.processCommandsGen(values.commands);
    }
  };

  // ============================================================================
  this.onLoadProcessLoad = function () {
    var obj = $("#id_onloadblock");
    if (obj == undefined) return;

    if (obj.hasClass("true")) return;
    obj.addClass("true");

    baseClass.onLoadProcessHeaderRequest(obj);
  };

  // ============================================================================
  this.processAjaxResultSuccessProcessCommands = function (
    data,
    info,
    status,
    xhr,
  ) {
    if (!xhr) return;
    var commands = xhr.getResponseHeader("commands");
    this.processCommandsGen(commands);
  };

  // ============================================================================
  this.processCommandsGen = function (commands) {
    if (!commands) return;
    if (commands == undefined) return;

    try {
      commands = JSON.parse(commands);
    } catch (e) {
      console.log(e);
      return;
    }

    for (var i in commands) {
      try {
        var c = commands[i];
        if (this.CommandExecuters[c.name] != undefined) {
          this.CommandExecuters[c.name](c);
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  // ============================================================================
  this.processAjaxResultSuccessProcessMeta = function (
    data,
    info,
    status,
    xhr,
  ) {
    if (!xhr) return info;
    var metaInfo = xhr.getResponseHeader("metaInfo");
    const mInfo = this.processMetaGen(metaInfo);
    if (mInfo) info.metaInfo = mInfo;
    return info;
  };

  // ============================================================================
  this.processMetaGen = function (metaInfo) {
    if (!metaInfo) return false;
    if (metaInfo == undefined) return false;

    try {
      metaInfo = JSON.parse(metaInfo);
    } catch (e) {
      console.log(e);
      return false;
    }

    if (metaInfo.title != undefined) {
      $("title").html(metaInfo.title);
      $('meta[name="DC.Title"]').attr("content", metaInfo.title);
      $('meta[property="og:title"]').attr("content", metaInfo.title);
      $('meta[property="twitter:title"]').attr("content", metaInfo.title);
    }

    if (metaInfo.metaKeyWords != undefined) {
      $('meta[name="keywords"]').attr("content", metaInfo.metaKeyWords);
    }

    if (metaInfo.metaDescription != undefined) {
      $('meta[name="description"]').attr("content", metaInfo.metaDescription);
      $('meta[property="og:description"]').attr(
        "content",
        metaInfo.metaDescription,
      );
      $('meta[property="twitter:description"]').attr(
        "content",
        metaInfo.metaDescription,
      );
    }

    if (metaInfo.metaImage != undefined) {
      $('meta[property="og:image"]').attr("content", metaInfo.metaImage);
      $('meta[property="twitter:image"]').attr("content", metaInfo.metaImage);
    }

    if (metaInfo.metaAuthor != undefined) {
      $('meta[name="author"]').attr("content", metaInfo.metaAuthor);
    }

    if (metaInfo.canonical != undefined) {
      $('link[rel="canonical"]').attr("href", metaInfo.canonical);
      $('meta[property="og:url"]').attr("content", metaInfo.canonical);
      $('meta[property="twitter:url"]').attr("content", metaInfo.canonical);
    }

    return metaInfo;
  };

  // ============================================================================
  this.processAjaxResultSuccessProcessHistory = function (data, info) {
    if (info.type == "ajaxHistory" && !info._notPushState) {
    // console.log('processAjaxResultSuccessProcessHistory', info,baseClass.isPopState);
      if (!baseClass.isPopState) 
      {
        // console.log('processAjaxResultSuccessProcessHistory register push', info.href);
        var title = document.title ?? "";
        history.pushState({ info, data, title }, title, info.href);
      }

      if (baseClass.isPopState) baseClass.isPopState = false;

      trackingTools.pageView({
        page_path: info?.href,
        page_title: title,
        page_type: info.type,
        source: "ajax",
      });
    }
  };

  // ============================================================================
  this.processAjaxResultSuccessProcessContent = function (data, info) {
    if (
      info.type == "ajaxHTML" ||
      info.type == "ajaxHistory" ||
      info.type == "ajax"
    ) {
      $("#" + info.targetid).html(data);
    }
    if (info.type == "ajaxAppend") {
      $("#" + info.targetid).append(data);
    }
  };
  // ============================================================================
  this.processAjaxResultSuccessProcessFinish = function (data, info) {
    this.OnReadyAll();
    if (info.inbackground == undefined || !info.inbackground) {
      // se cheama afisre loading ca inof
      this.HideIsLoadingInProgress();
    }

    if (info.type == "ajaxHistory" || info.scrolltargetid != undefined) {
      var targid =
        info.scrolltargetid != undefined ? info.scrolltargetid : info.targetid;
      var indent = info.scrollindent != undefined ? info.scrollindent : 0;

      this.scrolltargid(targid, indent);
    }

    // this.HideIsLoadingInProgress();
    // se cheama stopul
  };

  // ============================================================================
  this.scrolltargid = function (targid, indent) {
    var speed = "slow";

    var sc = parseInt($("#" + targid).offset().top);
    sc = isNaN(sc) ? 0 : sc;

    indent = indent != undefined ? parseInt(indent) : 0;
    indent = !isNaN(indent) ? indent : 0;

    if (indent == 0) {
      var siteindent = $("#datelabelinfo").data("siteindent");
      siteindent = siteindent != undefined ? parseInt(siteindent) : 0;
      siteindent = !isNaN(siteindent) ? siteindent : 0;
      indent = siteindent;
    }

    sc = sc + indent;

    if (
      $("#" + targid).is(":visible") &&
      parseInt($(window).scrollTop()) > sc
    ) {
      $("html,body").animate({ scrollTop: sc }, speed);
    } else if (
      $("#" + targid).is(":visible") &&
      parseInt($(window).scrollTop()) < sc
    ) {
      var objH = parseInt($("#" + targid).height());
      var windowH = parseInt($(window).height());

      if (objH >= windowH) {
        $("html,body").animate({ scrollTop: sc }, speed);
      } else if (parseInt($(window).scrollTop()) + windowH < sc + objH) {
        $("html,body").animate({ scrollTop: sc - (windowH - objH) }, speed);
      }
    }
  };

  // ============================================================================
  this.processAjaxResultSuccess = function (data, info, status, xhr) {
    info = this.processAjaxResultSuccessProcessMeta(data, info, status, xhr);
    this.processAjaxResultSuccessProcessHistory(data, info);
    this.processAjaxResultSuccessProcessContent(data, info);
    this.processAjaxResultSuccessProcessCommands(data, info, status, xhr);
    this.processAjaxResultSuccessProcessFinish(data, info);
    if (info.closeonclick) this.closeObjectsOnClick();
  };

  // ============================================================================
  this.processAjaxResultError = function (data, info) {
    this.processAjaxResultSuccessProcessFinish(data, info);
    this.HideIsLoadingInProgress();
    if (info.type == "ajaxHistory" && baseClass.isPopState) baseClass.isPopState = false;
  };

  // ============================================================================
  this.getAjaxPreloaded = function (info) {
    if (!window.__preloadedPages) window.__preloadedPages = {};

    const now = Date.now();

    const existing = window.__preloadedPages[info.url];
    if (existing && now - existing.timestamp < existing.maxAge) {
      return existing;
    }

    return false;
  };

  // ============================================================================
  this.saveAjaxPreloaded = function (
    data,
    info,
    status,
    xhr,
    maxAgeMs = 600000,
  ) {
    if (info.savepreload == undefined) return;
    if (!info.savepreload) return;

    if (!window.__preloadedPages) window.__preloadedPages = {};

    const now = Date.now();
    window.__preloadedPages[info.url] = {
      data: data,
      info: info,
      status: status,
      xhr: xhr,
      timestamp: now,
      maxAge: maxAgeMs,
    };
  };

  // ============================================================================
  this.getAjaxHTML = function (info, _method, _dataType) {
    const existing = baseClass.getAjaxPreloaded(info);
    if (existing) {
      baseClass.processAjaxResultSuccess(
        existing.data,
        info,
        existing.status,
        existing.xhr,
      );
      return;
    }

    if (_method == undefined) {
      _method = "get";
    }
    if (_dataType == undefined) {
      _dataType = "html";
    }

    if (info.inbackground == undefined || !info.inbackground) {
      // se cheama afisre loading ca inof
      this.ShowIsLoadingInProgress();
    }
    $.ajax({
      url: info.url,
      method: _method,
      dataType: _dataType,
      success: function (data, status, xhr) {
        baseClass.saveAjaxPreloaded(data, info, status, xhr);
        baseClass.processAjaxResultSuccess(data, info, status, xhr);
      },
      error: function (data, status, xhr) {
        baseClass.processAjaxResultError(data, info, status, xhr);
      },
    });
  };

  // ============================================================================
  this.loadAjaxPreloaded = function (info, _method, _dataType) {
    if (_method != undefined && _method != "get") {
      return;
    }

    const existing = baseClass.getAjaxPreloaded(info);
    if (existing) {
      return;
    }

    if (_dataType == undefined) {
      _dataType = "html";
    }

    const timeout = info.preloadtimeout ? info.preloadtimeout : 500;

    setTimeout(() => {
      $.ajax({
        url: info.url,
        method: _method,
        dataType: _dataType,
        success: function (data, status, xhr) {
          baseClass.saveAjaxPreloaded(data, info, status, xhr);
          baseClass.processAjaxPreloadedSuccess(data, info, status, xhr);
        },
      });
    }, 500);
  };

  // ============================================================================
  this.processAjaxPreloadedSuccess = function (data, info, status, xhr) {
    const temp = document.createElement("div");
    temp.innerHTML = data;
    const seen = new Set();
    $(temp)
      .find("img[src]")
      .each(function () {
        let src = $(this).attr("src");

        // Normalizează URL-ul (evită entități HTML &amp;)
        src = src.replace(/&amp;/g, "&");

        if (!src || seen.has(src)) return;
        seen.add(src);

        // Creează tag <link> doar dacă nu există deja
        if (!$(`link[rel="prefetch"][href="${src}"]`).length) {
          const tag = document.createElement("link");
          tag.rel = "prefetch";
          tag.as = "image";
          tag.href = src;
          document.head.appendChild(tag);

          const img = new Image();
          img.src = src;
        }
      });
  };

  // ============================================================================
  // ============================================================================
  // ============================================================================

  // ============================================================================
  this.OnReadyEventsAll = function (data, hideloading, targetid, allsite) {
    // -----------------------------------------------
    if (targetid == undefined) targetid = false;
    if (allsite == undefined) allsite = false;

    if (targetid && !allsite) {
      var findobj = $("#" + targetid);
    } else {
      var findobj = $("html");
    }
    // -----------------------------------------------

    this.needtwocheck = false;

    if (hideloading == undefined) hideloading = true;
    if (hideloading && data) {
      if (data != undefined && data && $(data).find(".js_nothideload").length) {
        hideloading = false;
      }
    }

    this.execreadall(data, findobj);

    if (this.needtwocheck)
      setTimeout(function () {
        this.execreadall(data, findobj);
      }, 50);

    if (!this.BeginedInSite && hideloading) this.HideIsLoadingInProgress();

    this.needtwocheck = false;
  };

  // ============================================================================
  this.execreadall = function (htmldata, findobj, afterfunction) {
    if (findobj == undefined) return;
    for (var i in this.OnReadyEventsArr) {
      try {
        this.OnReadyEventsArr[i](htmldata, findobj);
      } catch (e) {
        console.log(e);
      }
    }

    if (afterfunction != undefined) {
      try {
        afterfunction();
      } catch (e) {
        console.log(e);
      }
    }
  };

  // ============================================================================
  this.ShowIsLoadingInProgress = function () {
    var obj = $("#loadingind");
    //	if (obj) obj.show();
    if (obj && obj != undefined) obj.show();
  };

  // ============================================================================
  this.HideIsLoadingInProgress = function () {
    var obj = $("#loadingind");
    //	if (obj) obj.hide();
    obj.hide();
  };

  // ============================================================================
  this.putloadinindicator = function (targetid) {
    var obj = $("#loadingind-mini");
    if (obj != undefined) {
      var newobj = obj.clone();
      newobj.attr("id", "");
      newobj.show();
      $("#" + targetid).html(newobj);
    }
  };

  this.goTo = function (hash) {
    if (!History.pushState) {
      window.location.href = hash;
    } else {
      History.pushState(
        { url: hash, targetid: baseClass.targetid, rand: Math.random() },
        null,
        hash,
      );
      // console.log("TRACKINGTOOLS -> goTo - goTo");
      // if (this.useTracking)
      // {
      //   trackingTools.pageView();
      // }
      baseClass.langurl(hash);
      baseClass.ogurl();
    }
  };

  // ============================================================================
};;

var baseClass = new BASECLASSFUNCT();

export default baseClass;
